<template>
    <div
        class="grid grid-cols-2 flex-wrap gap-2 max-md:justify-between md:flex md:h-[31rem] md:flex-col md:gap-5 lg:h-[35.75rem]">
        <OurProductCard
            :to="`${fullPath ? 'https://cromi.ru' : ''}/radioguide/`"
            title="Радиогиды"
            class="max-md:order-1">
            <div
                class="pointer-events-none absolute bottom-0 left-0 right-0 size-full overflow-hidden lg:h-[200%] lg:w-[150%]">
                <picture>
                    <source
                        type="image/webp"
                        srcset="
                            /assets/images/products/radioguide/webp/reinvox-receiver-r-300-card.webp  422w,
                            /assets/images/products/radioguide/webp/reinvox-receiver-r-300.webp      1214w
                        "
                        sizes="(min-width: 1280px) 211px, (min-width: 1024px) 173px, 0px" />
                    <img
                        loading="lazy"
                        width="1214"
                        height="1012"
                        alt="Радиогид Receiver R-300"
                        src="/assets/images/products/radioguide/jpg-png/reinvox-receiver-r-300.png"
                        class="pointer-events-none absolute bottom-8 hidden aspect-[1214/1012] w-auto transition-all duration-700 ease-[cubic-bezier(0.19,1,0.22,1)] group-hover:-bottom-9 group-hover:right-1/2 group-hover:-rotate-[25deg] group-hover:scale-150 lg:left-14 lg:block lg:h-[9rem] xl:left-32 xl:h-[11rem]" />
                </picture>
                <picture>
                    <source
                        media="(max-width: 767px)"
                        type="image/webp"
                        srcset="
                            /assets/images/products/radioguide/webp/reinvox-duo-dark-mobile.webp
                        " />
                    <source
                        type="image/webp"
                        srcset="
                            /assets/images/products/radioguide/webp/reinvox-duo-dark-card.webp 232w,
                            /assets/images/products/radioguide/webp/reinvox-duo-dark.webp      488w
                        "
                        sizes="(min-width: 1280px) 116px, (min-width: 1024px) 107px, (min-width: 768px) 136px, 118px" />
                    <img
                        loading="lazy"
                        width="488"
                        height="860"
                        alt="Радиогид Reinvox DUO"
                        src="/assets/images/products/radioguide/jpg-png/reinvox-duo-dark.png"
                        class="group-pointer-events-none absolute -bottom-[40%] left-1/2 aspect-[488/860] h-[13rem] w-auto transition-all duration-700 ease-[cubic-bezier(0.19,1,0.22,1)] max-lg:-translate-x-1/2 max-sm:top-[20%] md:-bottom-1/2 md:h-[15rem] lg:bottom-3 lg:left-[38%] lg:h-[11.75rem] lg:group-hover:-bottom-4 lg:group-hover:rotate-[15deg] lg:group-hover:scale-150 xl:left-[43%] xl:h-[12.75rem]" />
                </picture>
            </div>
        </OurProductCard>
        <OurProductCard
            :to="`${fullPath ? 'https://cromi.ru' : ''}/cabin/`"
            title="Кабины переводчиков"
            size="md"
            class="max-md:order-4">
            <div
                class="pointer-events-none absolute left-0 right-0 top-0 size-full overflow-hidden lg:h-[120%]">
                <picture>
                    <source
                        media="(max-width: 767px)"
                        type="image/webp"
                        srcset="
                            /assets/images/products/cabin/webp/eurocab-1-mobile.webp
                        " />
                    <source
                        type="image/webp"
                        srcset="
                            /assets/images/products/cabin/webp/eurocab-1-card.webp 461w,
                            /assets/images/products/cabin/webp/eurocab-1.webp      690w
                        "
                        sizes="(min-width: 1280px) 230px, (min-width: 1024px) 217px, (min-width: 768px) 170px, 176px" />
                    <img
                        loading="lazy"
                        width="690"
                        height="713"
                        alt="Кабина переводчика EUROCAB-1"
                        src="/assets/images/products/cabin/jpg-png/eurocab-1.png"
                        class="pointer-events-none absolute left-1/2 top-1/3 aspect-[690/713] h-[11rem] w-auto -translate-x-1/2 transition-all duration-700 ease-[cubic-bezier(0.19,1,0.22,1)] md:top-1/4 lg:top-[22%] lg:h-[14rem] lg:group-hover:scale-125 xl:top-[18%] xl:h-[14.875rem]" />
                </picture>
            </div>
        </OurProductCard>
        <OurProductCard
            :to="`${fullPath ? 'https://cromi.ru' : ''}/audioguide/`"
            title="Аудиогиды"
            size="md"
            class="max-md:order-2">
            <div
                class="pointer-events-none absolute bottom-0 left-0 right-0 size-full overflow-hidden lg:h-[200%]">
                <picture>
                    <source
                        media="(max-width: 767px)"
                        type="image/webp"
                        srcset="
                            /assets/images/products/audioguide/webp/a1-bright-mobile.webp
                        " />
                    <source
                        type="image/webp"
                        srcset="
                            /assets/images/products/audioguide/webp/a1-bright.webp
                        " />
                    <img
                        loading="lazy"
                        width="212"
                        height="718"
                        alt="Аудиогид A1"
                        src="/assets/images/products/audioguide/jpg-png/a1-bright.png"
                        class="pointer-events-none absolute -bottom-1/2 left-1/2 aspect-[212/718] h-auto w-[4rem] -translate-x-1/2 transition-all duration-700 ease-[cubic-bezier(0.19,1,0.22,1)] max-sm:top-[20%] md:bottom-3 lg:bottom-3 lg:w-[4.75rem] lg:group-hover:-bottom-2 lg:group-hover:rotate-[15deg] lg:group-hover:scale-[180%] xl:bottom-4 xl:w-[5.25rem]" />
                </picture>
            </div>
        </OurProductCard>
        <OurProductCard
            :to="`${fullPath ? 'https://cromi.ru' : ''}/dostupsreda/`"
            title="Доступная среда"
            class="max-md:order-5">
            <div
                class="pointer-events-none absolute -bottom-10 -right-5 size-full overflow-hidden">
                <picture>
                    <source
                        media="(max-width: 767px)"
                        type="image/webp"
                        srcset="
                            /assets/images/products/available-environment/webp/accessible-environment-mobile.webp
                        " />
                    <source
                        type="image/webp"
                        srcset="
                            /assets/images/products/available-environment/webp/accessible-environment-card.webp 500w,
                            /assets/images/products/available-environment/webp/accessible-environment.webp      776w
                        "
                        sizes="(min-width: 1280px) 250px, (min-width: 1024px) 230px, (min-width: 768px) 195px, 181px" />
                    <img
                        loading="lazy"
                        width="776"
                        height="701"
                        alt="Доступная среда Reinvox"
                        src="/assets/images/products/available-environment/jpg-png/accessible-environment.png"
                        class="pointer-events-none absolute bottom-8 right-5 aspect-[776/701] h-[10rem] w-auto transition-all duration-700 ease-[cubic-bezier(0.19,1,0.22,1)] max-sm:h-[8rem] md:h-[11rem] lg:h-[13rem] lg:group-hover:bottom-2 lg:group-hover:right-[2.6rem] lg:group-hover:-rotate-[10deg] lg:group-hover:scale-125 xl:h-[14.125rem]" />
                </picture>
            </div>
        </OurProductCard>
        <OurProductCard
            :to="`${fullPath ? 'https://cromi.ru' : ''}/sinhroperevod/`"
            title="Оборудование синхронного перевода"
            class="max-md:order-3 max-md:overflow-hidden">
            <picture>
                <source
                    type="image/webp"
                    srcset="
                        /assets/images/products/sinhroperevod/webp/sinhroperevod.webp
                    " />
                <img
                    loading="lazy"
                    width="554"
                    height="306"
                    alt="Оборудование синхронного перевода SPBAUDIO Max-2"
                    src="/assets/images/products/sinhroperevod/jpg-png/sinhroperevod.png"
                    class="pointer-events-none absolute aspect-[554/306] transition-all duration-700 ease-[cubic-bezier(0.19,1,0.22,1)] max-md:left-[20%] max-md:top-16 max-md:h-3/4 md:bottom-3 md:h-auto md:w-[13rem] lg:bottom-3 lg:right-2 lg:w-[15rem] lg:group-hover:-right-4 lg:group-hover:bottom-1 lg:group-hover:rotate-[-15deg] lg:group-hover:scale-150 xl:w-[17.375rem]" />
            </picture>
        </OurProductCard>
        <OurProductCard
            :to="`${fullPath ? 'https://cromi.ru' : ''}/conference-system/`"
            title="Конференц-системы"
            size="md"
            class="overflow-hidden max-md:order-6">
            <picture>
                <source
                    media="(max-width: 767px)"
                    type="image/webp"
                    srcset="
                        /assets/images/products/conference-system/webp/reinvox-elegant-2-mobile.webp
                    " />
                <source
                    type="image/webp"
                    srcset="
                        /assets/images/products/conference-system/webp/reinvox-elegant-2-card.webp 331w,
                        /assets/images/products/conference-system/webp/reinvox-elegant-2.webp      530w
                    "
                    sizes="(min-width: 768px) 166px, 150px" />
                <img
                    loading="lazy"
                    width="530"
                    height="794"
                    alt="Конференц-система Reinvox Elegant-2"
                    src="/assets/images/products/conference-system/jpg-png/reinvox-elegant-2.png"
                    class="pointer-events-none absolute -bottom-5 left-1/2 aspect-[530/794] h-[8.5rem] w-auto -translate-x-1/2 transition-all duration-700 ease-[cubic-bezier(0.19,1,0.22,1)] max-sm:h-[7rem] md:bottom-3 md:h-[13.5rem] lg:right-[32%] lg:top-[20%] lg:h-[15.5rem] lg:group-hover:-rotate-[15deg] lg:group-hover:scale-125" />
            </picture>
        </OurProductCard>
    </div>
</template>

<script setup lang="ts">
import OurProductCard from '~/components/pages/home/our-products/OurProductCard.vue'

defineProps({
    fullPath: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
})
</script>
